"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Component", {
  enumerable: true,
  get: function get() {
    return _Component.default;
  }
});
Object.defineProperty(exports, "ComponentManager", {
  enumerable: true,
  get: function get() {
    return _ComponentManager.default;
  }
});
exports.plugins = void 0;

var _Component = _interopRequireDefault(require("./Component"));

var _ComponentManager = _interopRequireDefault(require("./ComponentManager"));

var plugins = _interopRequireWildcard(require("./plugins"));

exports.plugins = plugins;